import { FormbirdInjectorService } from '../injector/formbird-injector.service';
import { PageDownloadProgress } from '@formbird/types';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OfflineStatusService {

  offlineStatusService: any;

  offlineStatus: any;

  pageDownloadProgress: PageDownloadProgress;

  offlineStatus$: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.offlineStatusService = formbirdInjectorService.get('OfflineStatusService');
    this.offlineStatus$ = this.offlineStatusService.offlineStatus$;
    this.offlineStatus = this.offlineStatusService.offlineStatus;
    this.pageDownloadProgress = this.offlineStatusService.pageDownloadProgress;
  }

}
